var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { fromBalanceReportItem, fromBalanceReportBundle } from '@banking/ui/utils/activity';
import { GetBalanceReportRequest } from '@square/dashboard-protos/models/squareup/balancereporter/service';
import { BalanceReportItemStateCategory, ReportAccountId, ReportType } from '@square/dashboard-protos/models/squareup/balancereporter/model';
import { DateTime } from '@square/dashboard-protos/models/squareup/common/time';
import moment from 'moment';
import { getBrowserTimeZone } from '@dashboard/junk-drawer/utils/time';
import { inject as service } from '@ember/service';
function getClientCurrentTime() {
  return DateTime.create({
    instantUsec: moment().toDate().getTime() * 1000,
    tzName: [getBrowserTimeZone()]
  });
}

// This class integrates data from the BalanceReporter service with our client
// models (Activity and FormattedDetail).
let BalanceReporterActivity = (_class = class BalanceReporterActivity {
  constructor(apiService, activityDetailFormatter, featureService) {
    _defineProperty(this, "apiService", void 0);
    _defineProperty(this, "activityDetailFormatter", void 0);
    _initializerDefineProperty(this, "features", _descriptor, this);
    this.apiService = apiService;
    this.activityDetailFormatter = activityDetailFormatter;
    if (featureService) {
      this.features = featureService;
    }
  }
  async getActivities(query, category, batchRequest) {
    let activityStateCategory;
    let reportAccountId;
    let filters;
    switch (category) {
      case 'pending':
        activityStateCategory = BalanceReportItemStateCategory.PENDING;
        break;
      case 'completed':
        activityStateCategory = BalanceReportItemStateCategory.COMPLETED;
        break;
    }
    const owners = [];
    // Get card tokens from selected cards (exclude undefined/empty tokens)
    const cardTokens = query.selectedCards?.map(card => card.cardToken).filter(token => token !== undefined && token !== '');
    filters = {
      includeBalanceItemTypeCategories: query.selectedTypeCategory.value,
      minActivityOccurredAt: query.startAt,
      maxActivityOccurredAt: query.endAt,
      excludeNonDisputable: query.excludeNonDisputable,
      cardTokens: cardTokens && cardTokens.length > 0 ? cardTokens : undefined
    };
    for (const owner of query.activityOwners) {
      if (owner.type === 'account') {
        if (this.features.isEnabled('banking/access_folders') && !this.features.isEnabled('banking/access_sfs_savings')) {
          reportAccountId = ReportAccountId.create({
            reportType: ReportType.BANKING_FOLDER,
            id: owner.accountId
          });
          filters = {};
          if (owner.owner) {
            owners.push(owner.owner);
          }
        } else {
          throw new Error('cannot get activities with account id');
        }
      } else {
        owners.push(owner);
      }
    }
    const request = GetBalanceReportRequest.create({
      owners,
      activityStateCategory,
      filters,
      batchRequest,
      clientCurrentTime: getClientCurrentTime(),
      reportAccountId
    });
    const response = await this.apiService.getBalanceReport(request);
    if (response instanceof Error) {
      return response;
    }
    try {
      const activities = response.balanceReportLineItems.map(item => {
        if (item.balanceReportItem) {
          return fromBalanceReportItem(item.balanceReportItem);
        } else if (item.balanceReportItemBundle) {
          return fromBalanceReportBundle(item.balanceReportItemBundle);
        } else {
          throw new Error('Invalid balance report line item');
        }
      });
      return {
        activities,
        paginationToken: response.paginationToken.length > 0 ? response.paginationToken : null
      };
    } catch (error) {
      return new Error(`error processing balance report items: ${error}`);
    }
  }
  async getActivityDetails(id, _query) {
    const clientCurrentTime = getClientCurrentTime();
    const detail = await this.apiService.getBalanceReportItemDetails(id, clientCurrentTime);
    if (detail instanceof Error) {
      return detail;
    }
    try {
      return this.activityDetailFormatter(detail);
    } catch (error) {
      return new Error(`error processing balance report detail item: ${error}`);
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BalanceReporterActivity as default };